<div class="dialog-container" *ngIf="form" [formGroup]="form">

  <kendo-dialog [minWidth]="700" [width]="700" [maxHeight]="650" (close)="handleCloseDialog()"
    (click)="$event.stopPropagation()">
    <kendo-dialog-titlebar>
      <h2 class="section__heading !k-p-0">Upload Documents</h2>
    </kendo-dialog-titlebar>
    <div class="content">
      <div class="loading-container" *ngIf="loadSpinner">
        <kendo-loader *ngIf="loadSpinner" type="converging-spinner" size="large"></kendo-loader>
      </div>
      <div class="contact-details k-my-4">
        <div class="k-d-flex k-justify-content-stretch">
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <kendo-floatinglabel text="Document Type *" class="k-w-full">
              <kendo-dropdownlist [data]="uploadDocumentList" textField="description" valueField="id" rounded="large"
                size="large" formControlName="documentType">
              </kendo-dropdownlist>
            </kendo-floatinglabel>
          </div>
        </div>

      </div>
      <div class="contact-details k-my-4" *ngIf="showRequired">
        <div class="k-d-flex k-justify-content-stretch">
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <kendo-floatinglabel text="Request *" class="k-w-full">
              <kendo-dropdownlist [data]="consentReferralList" textField="requestDesc" valueField="consentSk"
                rounded="large" size="large" formControlName="request">
              </kendo-dropdownlist>
            </kendo-floatinglabel>
          </div>
        </div>

      </div>
      <div class="contact-details k-my-4" *ngIf="showConsentFields">
        <p><b>Evaluation List :</b></p>
        <div *ngFor="let item of consentDetails?.evaluations">{{ item }}</div>
      </div>

      <div class="contact-details k-my-4" *ngIf="showConsentFields">
        <p><b>Consent Provided : </b><span>{{consentDetails?.outcome === 1 ? "Yes" : consentDetails?.outcome === 2 ?
            "No" : "Not Received"}}</span></p>
        <p *ngIf="consentDetails?.outcome > 0"><b>Consent Date : </b><span>{{consentDetails?.validFromDate | date:
            'MM/dd/yyyy'}}</span></p>
      </div>

      <div class="contact-details k-my-4" *ngIf="!showDocuments">
        <div class="k-d-flex k-justify-content-stretch">
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <kendo-fileselect appFileRestrictions class="" [showFileList]="true" [multiple]="true"
              formControlName="filesList" (valueChange)="uploadDocumentPopUp($event)" #fileSelect>
            </kendo-fileselect>
            <kendo-label labelCssClass="hidden-label" [for]="fileSelect" text="Upload Documents"></kendo-label>
            <kendo-grid [data]="documents" scrollable="none" class="kendo-grid-doc">
              <kendo-grid-column field="uploadDate" title="Date">
                <ng-template kendoGridCellTemplate let-column>
                  {{column.uploadDate | date: 'MM/dd/yyyy'}}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="documentName">
                <ng-template kendoGridHeaderTemplate let-column>
                  <span>Details</span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
                  <a class="doc-name" role="button" tabindex="0" (click)="viewDocument(row)"
                    (keydown.enter)="viewDocument(row)" (keydown.space)="viewDocument(row)">
                    {{row.documentName}}
                  </a>
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </div>
        </div>


        <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">

        </div>
      </div>

      <!-- Consent Initial -->
      <div class="contact-details k-my-4 " *ngIf="consentInitial || medicaidConsent">
        <div class="k-d-flex k-justify-content-stretch">
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <kendo-formfield>
              <ul class="k-radio-list ">
                <li class="k-radio-item">
                  <input type="radio" #Yes value="Yes" formControlName="parentGuardianProvidedConsent"
                    kendoRadioButton />
                  <kendo-label [for]="Yes" text="Yes, Parent/Guardian provided consent."></kendo-label>
                </li>

                <li class="k-radio-item">
                  <input type="radio" #No value="No" formControlName="parentGuardianProvidedConsent" kendoRadioButton />
                  <kendo-label [for]="No" text="No, Parent/Guardian did not provide consent."></kendo-label>
                </li>
              </ul>
              <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
            </kendo-formfield>
          </div>
        </div>

      </div>
      <div class="contact-details k-my-4" *ngIf="(showDateSigned || medicaidConsent) && form?.value?.documentType?.id">
        <div class="k-d-flex k-justify-content-stretch">
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <kendo-formfield>
              <kendo-label [for]="dateSigned" class="student-document__label"
                [text]="consentInitial ?  'Date Signed' : (form?.value?.documentType?.id  === progressReportId ? 'Date of Progress Report': medicaidConsent ? 'Date of Consent' : 'Parent Signed Date') ">
                <span *ngIf="showRequiredMark">*</span>
              </kendo-label>

              <kendo-datepicker calendarType="classic" formControlName="dateSigned" rounded="large" [format]="format"
                placeholder="MM/DD/YYYY" [max]="todayDate" [min]="consentDetails?.consentDate ? minConsentDate : null"
                #dateSigned>
              </kendo-datepicker>

              <kendo-formerror *ngIf="form?.controls?.dateSigned?.errors?.required">Error: Date Signed is
                required</kendo-formerror>
              <kendo-formerror *ngIf="form?.controls?.dateSigned?.errors?.maxError">Error: Future Dates are not
                allowed</kendo-formerror>
              <kendo-formerror *ngIf="form?.controls?.dateSigned?.errors?.minError">Error: Date Signed can not be
                earlier than the Consent Date</kendo-formerror>

            </kendo-formfield>
          </div>

        </div>

      </div>
      <!-- PAL SEIT -->
      <div class="contact-details k-my-4" *ngIf=" showPlacementDate">
        <div class="k-d-flex k-justify-content-stretch">
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <kendo-formfield *ngIf="showPlacementDate">

              <kendo-label [for]="placementAuthorizationDate" class="student-document__label"
                text="Placement Authorization Date">
              </kendo-label>

              <kendo-datepicker calendarType="classic" formControlName="placementAuthorizationDate" rounded="large"
                [format]="format" placeholder="MM/DD/YYYY" #placementAuthorizationDate>
              </kendo-datepicker>

            </kendo-formfield>
          </div>

        </div>

      </div>
      <div class="contact-details k-my-4" *ngIf="showPlacementDate">
        <div class="k-d-flex k-justify-content-stretch">
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <kendo-formfield *ngIf="showPlacementDate">
              <kendo-label [for]="summerAuthorizationDate" class="student-document__label"
                text="Summer Authorization Date">
              </kendo-label>
              <kendo-datepicker calendarType="classic" formControlName="summerAuthorizationDate" [disabledDates]="
               disabledDates
               " [min]="summaryMinDate" [max]="summaryMaxDate" rounded="large" [format]="format"
                placeholder="MM/DD/YYYY" #summerAuthorizationDate>
              </kendo-datepicker>

            </kendo-formfield>
          </div>

        </div>

      </div>
      <div class="contact-details" *ngIf="showPlacementDate">
        <span class="k-form-separator !k-my-12"></span>
        <p class="k-mb-2">If the uploaded PAL has a SEIT Provider Agency, please indicate the agency below.</p>
        <div class="k-d-flex k-gap-4">
          <div class="searchRow">
            <div class="k-d-flex k-gap-4">
              <div class="k-flex-basis-3/4">
                <kendo-floatinglabel [text]="textFieldName.agency" class="!k-w-full">
                  <kendo-textbox size="large" rounded="medium" fillMode="solid" formControlName="agencyName">
                  </kendo-textbox>
                </kendo-floatinglabel>
              </div>
              <div class="k-flex-basis-1/4">
                <kendo-floatinglabel class="!k-w-full" [text]="textFieldName.location">
                  <kendo-textbox size="large" rounded="medium" fillMode="solid" formControlName="locationCode">
                  </kendo-textbox>
                </kendo-floatinglabel>
              </div>

            </div>
          </div>
          <div class="searchBtn k-align-self-end">
            <button kendoButton [size]="'large'" [rounded]="'large'" [fillMode]="'outline'" [themeColor]="'primary'"
              class="!k-w-full" [disabled]="!(form?.value?.locationCode || form?.value?.agencyName)"
              (click)="onAgencySearch()"> Search
            </button>
          </div>


        </div>
        <kendo-grid [data]="agencyData" [pageable]="true" [kendoGridBinding]="agencyData" [pageSize]="5"
          *ngIf="agencyData && !selectedAgency" scrollable="none" class="k-mt-6">
          <kendo-grid-column field="locationName" title="Agency Name" [width]="500" [headerClass]="'header-bg-color'">
            <ng-template kendoGridCellTemplate let-row>
              <p class="!k-font-semibold">{{row?.locationName}} </p>
              <p class="!k-m-0">
                {{ row?.addressLine1 }},
                {{ row?.addressLine2 }}<span *ngIf="row?.addressLine2">,</span>
                {{ row?.city }}, {{ row?.stateCode }} {{row?.zip}}
              </p>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="locationCode" title="Location Code" [headerClass]="'header-bg-color'">
          </kendo-grid-column>
          <kendo-grid-column field="buildingCode" title="Building Code" [headerClass]="'header-bg-color'">
          </kendo-grid-column>
          <kendo-grid-column field="geographicalDistrictCode" title="District" [headerClass]="'header-bg-color'">
          </kendo-grid-column>
          <kendo-grid-column title="" headerClass="action-column" [headerClass]="'header-bg-color'">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <button kendoButton size="medium" rounded="large" fillMode="solid" themeColor="primary"
                class="k-float-right" (click)="onselectAgency(dataItem)">
                Select
              </button>
            </ng-template>
          </kendo-grid-column>
          <ng-template kendoGridNoRecordsTemplate>
            <p *ngIf="!agencyData?.length">No Agencies available</p>
          </ng-template>
        </kendo-grid>

        <div class="k-d-flex k-flex-col k-mt-6 k-p-6 k-gap-6 selected-agency" *ngIf="selectedAgency">
          <h3 class="!k-m-0">Selected Agency</h3>
          <div class="k-d-flex k-gap-6">
            <div class="k-flex-basis-1/3">
              <span class="font-12">Agency</span>
              <p class="!k-font-semibold !k-m-0 ">{{selectedAgency?.locationName}}</p>
              <p class="!k-m-0">
                {{ selectedAgency?.addressLine1 }},
                {{ selectedAgency?.addressLine2 }}<span *ngIf="selectedAgency?.addressLine2">,</span>
                {{ selectedAgency?.city }}, {{ selectedAgency?.stateCode }} {{selectedAgency?.zip}}
              </p>
            </div>
            <div class="k-flex-basis-2/3">
              <div class="k-d-flex k-gap-6">
                <div class="k-flex-1">
                  <span class="font-12">Location Code</span>
                  <p class="!k-m-0">{{selectedAgency?.locationCode}}</p>
                </div>
                <div class="k-flex-1">
                  <span class="font-12">Building Code</span>
                  <p>{{selectedAgency?.buildingCode}}</p>
                </div>
                <div class="k-flex-1">
                  <span class="font-12">District</span>
                  <p>{{selectedAgency?.geographicalDistrictCode}}</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>


      <!-- Two Dates Dpi  -->
      <div class="contact-details k-my-4" *ngIf="dep1">
        <div class="k-d-flex k-justify-content-stretch">
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <!-- Kendo Floating Label for Requested Due By Date -->
            <kendo-formfield>
              <kendo-label class="student-document__label" [for]="chaipersonSignedDate"
                text="Chairperson Signed Date for Reconvene">
              </kendo-label>
              <!-- Kendo DatePicker -->
              <kendo-datepicker calendarType="classic" formControlName="chairpersonSignedDate" rounded="large"
                placeholder="MM/DD/YYYY" [format]="format" #chaipersonSignedDate>
              </kendo-datepicker>
            </kendo-formfield>
          </div>
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <!-- Kendo Floating Label for Extension Days Needed -->
            <kendo-formfield>
              <kendo-label class="student-document__label" [for]="parentSignedDate"
                text="Parent Signed Date for Reconvene">
              </kendo-label>
              <!-- Kendo DatePicker -->
              <kendo-datepicker calendarType="classic" formControlName="parentSignedDate" rounded="large"
                placeholder="MM/DD/YYYY" [format]="format" #parentSignedDate>
              </kendo-datepicker>
            </kendo-formfield>
          </div>

        </div>
      </div>

      <div class="contact-details k-my-4" *ngIf="dep1">
        <div class="k-d-flex k-justify-content-stretch">
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <kendo-label class="student-document__label" [for]="parentGuaridian"
              text="Did the Parent/Guardian consent to continue EI services?">
            </kendo-label>
            <kendo-textbox labelCssClass="hidden-label" #parentGuaridian></kendo-textbox>
            <kendo-formfield>
              <ul class="k-radio-list ">
                <li class="k-radio-item">

                  <input type="radio" #Yes value="Yes" formControlName="parentGuardianEIServices" kendoRadioButton />
                  <kendo-label [for]="Yes"
                    text="Yes, Parent/Guardian consented to continuing EI services."></kendo-label>


                </li>

                <li class="k-radio-item">
                  <input type="radio" #No value="No" formControlName="parentGuardianEIServices" kendoRadioButton />
                  <kendo-label [for]="No"
                    text="No, Parent/Guardian did not consent to continuing EI services."></kendo-label>
                </li>
              </ul>
              <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
            </kendo-formfield>
          </div>
        </div>

      </div>
      <div class="contact-details k-my-4" *ngIf="dep1">
        <div class="k-d-flex k-justify-content-stretch">
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <kendo-label class="student-document__label" [for]="parentConsentControl" text="Did the Parent/Guardian consent to have any EI service coordinator share any EI 
              service records developed after the initial meeting with the Committee on Preschool Special Education?">
            </kendo-label>
            <kendo-textbox labelCssClass="hidden-label" #parentConsentControl></kendo-textbox>
            <kendo-formfield>
              <ul class="k-radio-list ">
                <li class="k-radio-item">

                  <input type="radio" #Yes value="Yes" kendoRadioButton
                    formControlName="parentGuardianPreschoolSpecialEducation" />
                  <kendo-label [for]="Yes" text="Yes, Parent/Guardian provided consent."></kendo-label>


                </li>

                <li class="k-radio-item">
                  <input type="radio" #No value="No" formControlName="parentGuardianPreschoolSpecialEducation"
                    kendoRadioButton />
                  <kendo-label [for]="No" text="No, Parent/Guardian did not provide consent."></kendo-label>
                </li>
              </ul>
              <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
            </kendo-formfield>
          </div>
        </div>

      </div>
      <div class="contact-details k-my-4" *ngIf="dep1">
        <div class="k-d-flex k-justify-content-stretch">
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <kendo-formfield>
              <kendo-label class="student-document__label" [for]="parentConsentDate"
                text="Parent Consent Date for EI Service Coordinator">
              </kendo-label>
              <!-- Kendo DatePicker -->
              <kendo-datepicker calendarType="classic" formControlName="parentConsentDate" rounded="large"
                placeholder="MM/DD/YYYY" [format]="format" #parentConsentDate [max]="todayDate">
              </kendo-datepicker>
            </kendo-formfield>
          </div>
        </div>

      </div>

      <!-- PAL -->

      <!-- RelationShip -->

      <div class="contact-details k-my-4" *ngIf="consentInitial || dep1 || medicaidConsent">
        <div class="k-d-flex k-justify-content-stretch">
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <kendo-floatinglabel text="Relationship " class="k-font-semibold k-w-full">
              <kendo-dropdownlist [data]="relationshipList" rounded="large" size="medium"
                formControlName="relationshipRRR" textField="description" valueField="id"
                (valueChange)="onRelationshipValChange($event)">
              </kendo-dropdownlist>
            </kendo-floatinglabel>
          </div>
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <kendo-floatinglabel text="Printed Name " class="k-font-semibold k-w-full">
              <kendo-textbox [clearButton]="true" size="medium" rounded="large" [fillMode]="'outline'"
                formControlName="printedNameRRR">
              </kendo-textbox>
            </kendo-floatinglabel>
            <kendo-formerror>{{ form.get('printedNameRRR')?.errors?.validateName?.message }}</kendo-formerror>
          </div>
        </div>
      </div>

      <div class="contact-details k-my-4" *ngIf="medicaidConsent">
        <div class="k-d-flex k-justify-content-stretch">
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <kendo-floatinglabel text="Medicaid Client Identification Number (CIN)" class="k-font-semibold k-w-full ">
              <kendo-textbox size="medium" rounded="large" [fillMode]="'outline'"
                formControlName="mcin">
              </kendo-textbox>
            </kendo-floatinglabel>
          </div>
        </div>
      </div>


      <div class="contact-details k-my-4" *ngIf="showOther">
        <div class="k-d-flex k-justify-content-stretch">
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <kendo-floatinglabel text="Other" class="k-font-semibold k-w-full ">
              <kendo-textbox [clearButton]="true" size="medium" rounded="large" [fillMode]="'outline'"
                formControlName="otherCEM">
              </kendo-textbox>
            </kendo-floatinglabel>
          </div>
        </div>
      </div>

      <div class="contact-details k-my-4" *ngIf="showPartialServiceProvided">
        <div class="k-d-flex k-justify-content-stretch">
          <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
            <kendo-floatinglabel text="Partial Service(s) Provided" class="k-font-semibold k-w-full">
              <kendo-multiselect [data]="providerServices" rounded="large" size="medium"
                formControlName="partialServiceProvided" textField="id" valueField="id"
                [valuePrimitive]="true"></kendo-multiselect>
            </kendo-floatinglabel>
          </div>

        </div>
      </div>
    </div>
    <kendo-dialog-actions>
      <button kendoButton themeColor="primary" size="medium" rounded="large" fillMode="solid" class="k-w-full"
        (click)="checkIfDocTypeIsConsentForAddAssessment()"
        [disabled]="!form?.valid || isSaveDisabled || (consentDetails && !consentDetails?.consentDate)">
        Save
      </button>
    </kendo-dialog-actions>
    <kendo-formerror data-testid="upload-consent-error-message"
      *ngIf="consentDetails && !consentDetails?.consentDate && this.form?.value?.documentType?.id === consentForAdditionalAssessmentId ">Error:
      Please
      upload Consent for Initial/Reevaluation to upload consent for additional assessment(s)</kendo-formerror>
    <div class="k-d-flex k-justify-content-between k-pt-6"></div>
  </kendo-dialog>
</div>
<!-- Confirmation Dialog -->
<kendo-dialog
  [title]="form?.value?.parentGuardianProvidedConsent === 'No'? 'Confirm Parental Non-Consent' : 'Confirm Parental Consent'"
  (close)="showConfirmationDialog = false;" [minWidth]="530" [width]="530" [height]="332" id="confirmation-popup"
  [ngClass]="form?.value?.parentGuardianProvidedConsent === 'No' ? 'consent-no' : 'consent-yes'"
  *ngIf="showConfirmationDialog">
  <kendo-dialog-messages>
    <div>
      Are you sure you want to continue with <b>{{form?.value?.dateSigned | date: 'MM/dd/yyyy'}}</b> as the date <b>
        parental consent was
        <div class="k-d-inline" *ngIf="form?.value?.parentGuardianProvidedConsent === 'No'">not</div> provided?
      </b>
    </div>
    <div class="error-body !k-p-4 !k-mt-4">
      <p class="!k-font-bold !k-mb-0 !k-mt-0" style="color:#BD0026"><fa-icon icon="triangle-exclamation" class="k-mr-2"
          size="lg"></fa-icon> This action is irreversible.</p>
      <p class="!k-mt-0 !k-mb-0 !k-ml-8">{{form?.value?.parentGuardianProvidedConsent === 'No' ? 'Upon confirmation,
        please proceed to the case closing process for this student.' : 'Compliance timelines will be calculated from
        this date upon confirmation.'}}</p>
    </div>
  </kendo-dialog-messages>
  <kendo-dialog-actions>
    <button kendoButton (click)="showConfirmationDialog = false;"
      [themeColor]="form?.value?.parentGuardianProvidedConsent === 'Yes' ? 'primary' : 'error'" fillMode="outline">No,
      Go Back</button>
    <button kendoButton (click)="uploadDocuments();showConfirmationDialog = false;"
      [themeColor]="form?.value?.parentGuardianProvidedConsent === 'Yes' ? 'primary' : 'error'">
      Yes, Confirm
    </button>
  </kendo-dialog-actions>
</kendo-dialog>